/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingTab_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingRelatedContent_item">;
    readonly " $refType": "PdpRespStorytellingTab_item";
};
export type PdpRespStorytellingTab_item$data = PdpRespStorytellingTab_item;
export type PdpRespStorytellingTab_item$key = {
    readonly " $data"?: PdpRespStorytellingTab_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingTab_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespStorytellingTab_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingRelatedContent_item",
      "args": null
    }
  ]
};
(node as any).hash = 'b454201e6f6aba9987c6f3588d6bb1ee';
export default node;
